import { PageHeader, ScreenStub } from '@/components/page'

/*
 * Screens that exist in the Phase 1 prototype but have no backend endpoint yet.
 * Each is a deliberate stub rather than a half-wired screen — see the prototype
 * at cwc-backend-v1/docs/prototypes/internal-ops-console-prototype.html for the
 * intended layout and behaviour.
 */

export function DashboardPage() {
  return (
    <>
      <PageHeader title="Dashboard" />
      <ScreenStub title="Dashboard — coming soon">
        Metrics are not scoped for Phase 1. The prototype ships this screen as a placeholder too.
      </ScreenStub>
    </>
  )
}

export function NotFoundPage() {
  return (
    <>
      <PageHeader title="Not found" />
      <ScreenStub title="404">That screen does not exist in the console.</ScreenStub>
    </>
  )
}
